<template>
  <div>
    <div class="page-header">
      <h1>
        Assignment Terms Export
      </h1>
    </div>
    <b-col md="5">
      <b-alert variant="success"
               dismissible
               fade
               :show="showSuccessfulFormSubmit"
               @dismissed="showSuccessfulFormSubmit=false">
        Thank you for submitting the request. You will receive an email with the CSV file shortly.
      </b-alert>
    </b-col>
    <b-col md="4" v-if="errors.length">
      <ErrorsContainer :errors="errors" />
    </b-col>
    <b-col md="4">
      <div class="alert alert-warning">
        A postal code must also have a country selected.
        <br />
        This export generates data only for instant buy vendors.
      </div>
    </b-col>
    <b-form @submit.prevent="submitForm" inline>
      <label class="pr-2">Products:</label>
      <v-select v-model="selectedProducts"
                :options="activeProducts"
                class="mb-2 mr-sm-2 mb-sm-0 products-select"
                multiple>
      </v-select>
      <label class="sr-only" for="inline-form-input-postal-code">Postal code:</label>
      <b-input id="inline-form-input-postal-code"
               type="text"
               v-model="postalCode"
               class="mb-2 mr-sm-2 mb-sm-0"
               placeholder="Postal code"/>
      <label class="sr-only" for="inline-form-input-country">Country:</label>
      <b-form-select v-model="selectedCountry"
                     :options="countriesListForSelect"
                     id="inline-form-input-country"
                     class="mb-2 mr-sm-2 mb-sm-0">
        <template slot="first">
          <option :value="null" disabled>Please choose a country</option>
        </template>
      </b-form-select>
      <b-form-checkbox v-model="onlyActiveVendors" class="checkbox-item">
        Only active vendors
      </b-form-checkbox>
      <b-form-checkbox v-model="withDistrictCodes" class="checkbox-item">
        With district codes
      </b-form-checkbox>
        <b-button type="submit" variant="success">CSV</b-button>
    </b-form>
  </div>
</template>
<script>
import ProductsProvider from '@/services/ProductsProvider'
import ExportsProvider from '@/services/ExportsProvider'
import CountriesProvider from '@/services/CountriesProvider'
import ErrorsContainer from '@/components/ErrorsContainer'

export default {
  name: 'AssignmentTermsExport',
  data () {
    return {
      onlyActiveVendors: true,
      withDistrictCodes: true,
      activeProducts: [],
      selectedProducts: [],
      combinedDistrictCodes: [],
      errors: [],
      selectedCountry: null,
      postalCode: '',
      showSuccessfulFormSubmit: false
    }
  },
  mounted () {
    this.applyActiveProducts()
  },
  methods: {
    applyActiveProducts () {
      ProductsProvider.activeProducts()
        .then((resp) => {
          this.activeProducts = resp.body.products.map((product) => {
            return { value: product.id, label: product.name }
          })
        })
    },
    submitForm () {
      if (this.selectedCountry === null && this.postalCode !== '') {
        this.errors.push('A postal code must also have a country selected.')
      } else if (this.selectedProducts.length === 0) {
        this.errors.push('Please select at least one product')
      } else {
        let params = {
          active: this.onlyActiveVendors,
          zipcode: this.postalCode,
          product_ids: this.productIds,
          country_code: this.selectedCountry,
          with_district_codes: this.withDistrictCodes
        }
        return new Promise((resolve, reject) => {
          ExportsProvider.create('assignment_terms_export', params)
            .then(resp => {
              this.showSuccessfulFormSubmit = true
              setTimeout(() => {
                this.showSuccessfulFormSubmit = false
              }, 10000)
              resolve(resp)
            }, (resp) => {
              this.errors.push(resp.body.error)
              resolve(resp)
            })
        })
      }
    }
  },
  computed: {
    countriesListForSelect () {
      let exceptList = this.combinedDistrictCodes.map(dc => dc.countryCode)
      return CountriesProvider.forSelect().filter(country => {
        return exceptList.indexOf(country.value) < 0
      })
    },
    productIds () {
      let productIds = []
      this.selectedProducts.forEach(function (product) {
        productIds.push(product.value)
      })
      return productIds
    }
  },
  components: {
    ErrorsContainer
  }
}
</script>

<style scoped>
.products-select {
  min-width: 185px;
}

.checkbox-item {
  margin-right: 1rem;
}
</style>
